document.addEventListener('DOMContentLoaded', function() {
  function isElementCentered(elem) {
    const rect = elem.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const elemMiddle = rect.top + rect.height / 2;
    // Rendre visible un peu avant le centre (60% de la hauteur de l'écran)
    return elemMiddle > windowHeight * 0.4 && elemMiddle < windowHeight * 0.7;
  }

  function isElementAboveViewport(elem) {
    const rect = elem.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const elemBottom = rect.top + rect.height;
    return elemBottom < windowHeight * 0.4;
  }

  function handleScroll() {
    const benefits = document.querySelectorAll('.benefit');
    
    if (window.innerWidth <= 749) {
      benefits.forEach(benefit => {
        if (isElementCentered(benefit)) {
          benefit.classList.add('benefit--active');
        }
        if (isElementAboveViewport(benefit)) {
          benefit.classList.add('benefit--active');
        }
      });
    }
  }

  handleScroll();
  window.addEventListener('scroll', handleScroll);
});
